import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditReturnTopBarComponent } from './edit-return-top-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { VoidRecordModule } from 'src/app/widgets/records/void-record/void-record.module';
import { FinalizeRecordModule } from 'src/app/widgets/records/finalize-record/finalize-record.module';
import { ProcessingDialogModule } from 'src/app/widgets/processing-dialog/processing-dialog.module';
import { RecordListBackButtonModule } from 'src/app/components/record-list-back-button/record-list-back-button.module';
import { PillStatusModule } from 'src/app/components/pill-status/pill-status.module';

@NgModule({
  declarations: [EditReturnTopBarComponent],
  exports: [EditReturnTopBarComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    PillStatusModule,
    ProcessingDialogModule,
    RecordListBackButtonModule,
    RouterModule,
    VoidRecordModule,
    FinalizeRecordModule
  ]
})
export class EditReturnTopBarModule { }
